export * from './alert.component';



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_directives/index.ts